import { useTranslation } from 'next-i18next'
import { useContext } from 'react'

import { LatestSearchCookieRegistry } from '@/constants/cookieRegistry'
import { SearchContext } from '@/contexts/SearchContext'
import { useSrpContext } from '@/contexts/SrpContext'
import { isSortByDropdownValueValid } from '@/domain/srp/isSortByDropdownValueValid'
import { type DropdownItem, Dropdown } from '@/ui/molecules/dropdown'
import { updateLatestSearchCookie } from '@/utils/cookies/latestSearchCookie'
import sendToLogger from '@/utils/sendToLogger'
import { capitalizeFirstWord } from '@/utils/string'

import { SrpSortContainer } from './styled'

export const SrpSort = () => {
  const { sorting, sortKey } = useSrpContext()

  //Update the 'sf' cookie with the latest search value passed by Anvil
  updateLatestSearchCookie({ [LatestSearchCookieRegistry.SORT_KEY]: sortKey })

  const { handleSortByChange } = useContext(SearchContext)
  const { t } = useTranslation('srp')

  const onSelectChange = (item?: DropdownItem) => {
    if (item?.value === sortKey) return

    /**
     * Change URL to contain selected sort key if valid
     */
    if (item && isSortByDropdownValueValid(item.value)) {
      handleSortByChange(item.value)
    } else {
      sendToLogger(`SRP Sorting - selected value not a valid sort option - value:${item?.value}`)
    }
  }

  /**
   * Map options to the format that DropdownItem expects
   *  */
  const options = sorting.reduce((acc: DropdownItem[], curr) => {
    const item = {
      label: curr.label,
      value: `${curr.by.toLowerCase()}${capitalizeFirstWord(curr.direction)}`,
    }

    return [...acc, item]
  }, [])

  return (
    <SrpSortContainer>
      <Dropdown
        id="srp-sort"
        selectedValue={sortKey}
        options={options}
        label={t('sort_dropdown.label')}
        onSelectChange={onSelectChange}
        data-testid="search-sort-dropdown"
      />
    </SrpSortContainer>
  )
}
